var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeachers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97449 2.08462C2.63138 3.42773 1.89453 5.21388 1.89453 7.1073C1.89453 11.0247 5.08442 14.2099 8.99717 14.2099C10.8906 14.2099 12.6767 13.4684 14.0198 12.1253C15.3629 10.7822 16.1045 8.99605 16.1045 7.10263C16.1045 3.18523 12.9146 0 8.99717 0C7.10375 0 5.3176 0.74151 3.97449 2.08462ZM14.225 7.10263C14.225 8.49704 13.6794 9.80751 12.6954 10.7962C11.7067 11.7849 10.3962 12.3305 9.00183 12.3305C6.1244 12.3305 3.77862 9.98939 3.77862 7.1073C3.77862 5.71289 4.32426 4.40242 5.31294 3.41374C6.30161 2.42506 7.61208 1.87942 9.00649 1.87942C11.8793 1.87942 14.225 4.22054 14.225 7.10263Z",
    fill: "#AFDDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.937543 25.0853L17.0595 25.0806C17.5679 25.0806 17.9829 24.6795 17.9969 24.1712C18.0062 23.9194 18.1601 17.9173 14.3873 14.4616C14.0515 14.1538 13.5432 14.1305 13.1794 14.4103C13.1375 14.443 8.96356 17.5769 5.08813 14.4196C4.73369 14.1305 4.22536 14.1398 3.87559 14.4383C3.72169 14.5735 0.0887673 17.8007 0.000159259 24.1292C-0.00450432 24.3811 0.0934317 24.6236 0.270648 24.8008C0.4432 24.9827 0.68571 25.0853 0.937543 25.0853ZM4.59845 16.3923C7.98887 18.6449 11.6311 17.5769 13.6318 16.3737C15.5439 18.5376 15.9916 21.6715 16.0942 23.2012L1.92622 23.2058C2.2107 19.6195 3.76833 17.3577 4.59845 16.3923Z",
    fill: "#AFDDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachers);
export default __webpack_public_path__ + "static/media/teachers.fac3b7c44ed7d5f62a747b9d20fd1652.svg";
export { ForwardRef as ReactComponent };